<template>
  <GroupSelect
    data-test-id="edit-group-cell-renderer"
    :entity-type="entityType"
    :project-groups="projectEntityGroups"
    v-model="groupIds"
  />
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import GroupSelect from '@components/GroupSelect.vue';
import { ICellEditorParams } from 'ag-grid-community';
import { ProjectGroupsDocument, ProjectGroupsQuery } from '@/graphql/operations.gen';
import {
  ProjectCode,
  ProjectCodeGroup,
  ProjectMemoGroup,
  ProjectSourceGroup,
  ProjectMemo,
  ProjectSource,
} from '@/types';

export default defineComponent({
  name: 'EditGroupCellRenderer',
  components: { GroupSelect },
  mounted() {
    this.groupIds = this.params.value.map((val) => val.id);
    this.$el.addEventListener('click', this.handleClick);
  },
  beforeUnmount() {
    this.$el.removeEventListener('click', this.handleClick);
  },

  props: {
    params: {
      type: Object as PropType<
        { projectId: string } & ICellEditorParams<
          ProjectCode | ProjectMemo | ProjectSource,
          Array<ProjectCodeGroup | ProjectMemoGroup | ProjectSourceGroup>
        >
      >,
      required: true,
    },
  },

  data(): {
    groupIds: Array<string>;
    project: ProjectGroupsQuery['project'];
  } {
    return {
      groupIds: [],
      project: undefined,
    };
  },
  apollo: {
    project() {
      return {
        query: ProjectGroupsDocument,
        fetchPolicy: 'cache-only',
        variables: {
          id: this.params.projectId,
        },
      };
    },
  },
  methods: {
    handleClick(event: MouseEvent): void {
      event.stopPropagation();
    },
    /**
     * Called after editing has finished to get the new value
     *
     * @public
     */
    getValue() {
      if (!this.projectEntityGroups) {
        return [];
      }

      // groups might have been deleted while editing
      return this.groupIds.flatMap((value) => this.projectEntityGroups.find((val) => val.id === value) || []);
    },
  },
  computed: {
    projectEntityGroups(): Array<ProjectCodeGroup | ProjectMemoGroup | ProjectSourceGroup> {
      if (!this.project) {
        return [];
      }

      return this.project[`${this.entityType}Groups`];
    },
    entityType(): 'code' | 'memo' | 'source' {
      return this.params.data.__typename.toLowerCase();
    },
  },
});
</script>
<style lang="scss" scoped>
.edit-group-cell-renderer__icon-button {
  margin-left: 4px;
}
</style>
